module.exports = __webpack_public_path__ + "img/moncalieri_hero_card.59736966.png";